import { PrismicLink, TextFromRichText } from './PrismicTypes';

export const GENERIC_DEBT_CONSOLIDATION_CALCULATOR = 'PrismicGenericTemplateDataBodyDebtConsolidationCalculator';

export interface GenericDebtConsolidationCalculatorPrimary {
  button_text?: TextFromRichText;
  button_link?: PrismicLink;
  disclaimer?: TextFromRichText;
  result_body?: TextFromRichText;
  result_heading?: TextFromRichText;
}

export interface GenericDebtConsolidationCalculatorContent {
  __typename: typeof GENERIC_DEBT_CONSOLIDATION_CALCULATOR;
  primary: GenericDebtConsolidationCalculatorPrimary;
}
